/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'modal';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ModalSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    FULLSCREEN = 'fullscreen',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ModalVariant {
    DEFAULT = 'default',
    HOLOGRAPHIC = 'holographic',
}
